module.exports = __webpack_public_path__ + "img/1.b22f27ca.png";